import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 120000,
});

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('auth_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            // Server responded with error status
            console.error('API Error:', error.response.data);

            if (error.response.status === 401) {
                // Session invalid/expired (or the JWT secret rotated): clear the
                // stale credentials and send the user to login. Auth endpoints are
                // excluded — a wrong password must not trigger a redirect loop.
                const url: string = error.config?.url || '';
                const onAuthPage = ['/login', '/signup', '/forgot-password', '/reset-password'].some((p) =>
                    window.location.pathname.startsWith(p),
                );
                if (!url.includes('/auth/') && !onAuthPage) {
                    localStorage.removeItem('auth_token');
                    localStorage.removeItem('user');
                    window.location.assign('/login');
                }
            }
        } else if (error.request) {
            // Request made but no response
            console.error('Network Error:', error.request);
        } else {
            // Something else happened
            console.error('Error:', error.message);
        }

        return Promise.reject(error);
    }
);

export default apiClient;
